$(document).ready(function() {
  var delivery_region = '';
  var default_region = 'United_Kingdom';
  delivery_region = getCookie("delivery_region");
  if(delivery_region==""){
    setHeaderDeliveryRegion(default_region);
  }
  
  //console.log("delivery_region: " + delivery_region);

  /*$.get("http://ipinfo.io", function (response) {
    //console.log("Response: " + response.country);
    var dr = '';
    if(response.country!='GB'){
      $('#deliveryRegionModal').modal('show');
      dr = 'United_Kingdom';
    }else if(delivery_region!=""){
      setCookie("delivery_region", delivery_region, 1);
      dr = delivery_region;
    }else{
      setCookie("delivery_region", default_region, 1);
      dr = default_region;
    }
    setHeaderDeliveryRegion(delivery_region);
  }, "jsonp");*/


  
  if(delivery_region==""){
    $.get("http://ipinfo.io", function (response) {
      //console.log("Response: " + response.country);
      var dr = '';
      if(response.country!='GB'){
        $('#deliveryRegionModal').modal('show');
        dr = 'United_Kingdom';
      }else if(delivery_region!=""){
        setCookie("delivery_region", delivery_region, 1);
        dr = delivery_region;
      }else{
        setCookie("delivery_region", default_region, 1);
        dr = default_region;
      }
      setHeaderDeliveryRegion(delivery_region);
    }, "jsonp");
  }else{
    setHeaderDeliveryRegion(delivery_region);
  }
  

  $("input:radio[name='av_region']").change(function(){
      var _val = $(this).val();
      setCookie("delivery_region", _val, 1);

      console.log("cvalue: ", _val);
      setHeaderDeliveryRegion(_val);
      $('#deliveryRegionModal').modal('hide');
      resetProductDetail();
  });

  $(".region_dropdown img.flag").addClass("flagvisibility");

  $(".region_dropdown dt a").click(function() {
      $(".region_dropdown dd ul").toggle();
  });

  $(".region_dropdown dd ul li a").click(function() {
      var text = $(this).find('span.region_logos').html();
      $(".region_dropdown dt a span").html(text);
      $(".region_dropdown dd ul").hide();
      var dateFor = $(this).data('for');
      setCookie("delivery_region", dateFor, 1);
      $("input[name=av_region][value=" + dateFor + "]").prop('checked', true);
      //$("#result").html("Selected value is: " + getSelectedValue("sample"));
      resetProductDetail();
  });

  $(document).bind('click', function(e) {
      var $clicked = $(e.target);
      if (! $clicked.parents().hasClass("region_dropdown"))
          $(".region_dropdown dd ul").hide();
  });
  $(".region_dropdown img.flag").toggleClass("flagvisibility");
});

jQuery( document ).ready(function() {
  setTimeout(function(){
    resetProductDetail();

    if(jQuery('select#productSelect-option-0').length>0){
      var variant_str = jQuery(".product_variants_detail").attr("data-variant");
      var variant_object = JSON.parse(decodeURIComponent(variant_str));
      jQuery('select#productSelect-option-0 option').each(function() {
        var checked = '';
        if(variant_object.option1==jQuery(this).attr('value')){
          var checked = 'checked';
        }
        var html = '';
        html += '<li>';
        html += '<input type="radio" name="format_variant" value="' + jQuery(this).attr('value') + '" ' + checked + '>';
        html += '<label for="' + jQuery(this).attr('value') + '">' + jQuery(this).attr('value') + '</label>';
        html += '</li>';
        jQuery('.format_radio_toolbar').append(html);
      });
    }
  }, 300);

  jQuery(document).on('change', 'input[type="radio"][name="format_variant"]', function (e) {
    jQuery('#productSelect-option-0')
      .find('option[value="'+jQuery(this).val()+'"]')
      .prop('selected',true)
      .trigger('change');

    resetProductDetail();
  });

  jQuery(document).on('change', '#productSelect-option-0', function (e) {
    getVariantDetail();
  });
});

function getVariantDetail(){
  var inventory_quantity = 0;
  var requires_shipping = true;   // true if physical product and false for digital
  var sku = '';
  var variant_str = jQuery(".product_variants_detail").attr("data-variant");
  
  var variant_object = JSON.parse(decodeURIComponent(variant_str));
  console.log("variant_object: ", variant_object);
  
  inventory_quantity = variant_object.inventory_quantity;
  requires_shipping = variant_object.requires_shipping;
  sku = variant_object.sku;

  return variant_object;
}

function resetProductDetail(){
  var delivery_region = getCookie("delivery_region");
  var variantDetal = getVariantDetail();
  var isPhysical = variantDetal.requires_shipping;
  var quantity = variantDetal.inventory_quantity;
  var inventory_policy = variantDetal.inventory_policy; // 1. "continue" for sell after out of stock AND "deny" for stop sell after out of stock
  var sku = variantDetal.sku;
  var title = variantDetal.title;
  var compare_at_price = variantDetal.compare_at_price;

  var productPriceColor = jQuery('.variant_price #ProductPrice');
  productPriceColor.removeClass("bluetext redtext");
  if(compare_at_price==null || compare_at_price==""){
    jQuery('#ComparePrice .money').text("");
    productPriceColor.addClass('bluetext');
  }else{
    productPriceColor.addClass('redtext');
  }
  
  var us_asin = variantDetal.us_asin;
  var asin = variantDetal.asin;

  var publication = variantDetal.itemdate;
  //var options = { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' };
  var options = { year: 'numeric', month: 'long' };
  publication  = new Date(publication);
  publication = publication.toLocaleDateString("en-US", options); // Saturday, September 17, 2016

  var storeUrl = 'https://ingram-indiepubsuk.myshopify.com/cart?isbn=' + sku + '&publishername=pelagic-publishing';
  var notifymeUrl = 'https://pelagicpublishing.com/pages/notify-me';

  var variant_price = $('.variant_price');
  var variant_stock_msg = $('.variant_stock_msg');
  //var variant_quantity = $('.variant_quantity');
  var variant_addtocart_button = $('.variant_addtocart_button');
  var variant_shipping_msg = $('.variant_shipping_msg');

  var variant_quantity = $('.variant_quantity input#Quantity');
  variant_quantity.show();

  if(delivery_region=="" || delivery_region==null || delivery_region==undefined){
    delivery_region = 'United_Kingdom';
  }

  setTimeout(function(){
    if(isPhysical){
      //Physical Product
      var stockMessage = '';
      var shippingMsg = '';
      var shippingHtml = '';
      var buttonHtml = '';
      if(quantity>0){
        
        //Product In Stock
        stockMessage = 'In Stock';
        
        //alert(delivery_region);
        if(delivery_region=='United_Kingdom' || delivery_region=='USA_Canada'){
          buttonHtml = '<button type="submit" name="add" id="AddToCart" class="btn"><i class="icon-shopping-cart"></i>  <span id="AddToCartText">Add to Basket</span></button>';
          
          if(delivery_region=='USA_Canada'){

            shippingMsg = 'Shipped from the USA';
          }
        }else{
          //alert("22");
          buttonHtml = '<a href="'+storeUrl+'" target="_blank" class="storeRedirectToCart btn"><i class="icon-shopping-cart"></i>  <span id="AddToCartText">Add to Basket</span></a>';
          variant_quantity.hide();
        }
      }else{
        //Product Out of Stock
        stockMessage = 'Publication: ' + publication;
        
        if(delivery_region=='United_Kingdom' || delivery_region=='USA_Canada'){

          if(delivery_region=='USA_Canada'){
            shippingMsg = 'Shipped automatically from the USA on publication.';
          }else{
            shippingMsg = 'Shipped automatically on publication.';
          }

          if(inventory_policy=="continue"){
            buttonHtml = '<button type="submit" name="add" id="AddToCart" class="btn"><i class="icon-shopping-cart"></i>  <span id="AddToCartText">Preorder</span></button>';
            //buttonHtml = '<input id="preorder-me-btn" data-label="Preorder" type="submit" class="btn pre-order" value="Preorder">';
          }else{
            shippingMsg = '';
            buttonHtml = '<a href="'+notifymeUrl+'" target="_blank" class="notifyme_btn btn">Notify Me</a>';
            variant_quantity.hide();
          }

        }else{
          //alert("22");
          if(inventory_policy=="continue"){
            shippingMsg = 'Shipped automatically on publication.';
            buttonHtml = '<a href="'+storeUrl+'" target="_blank" class="storeRedirectToCart btn"><i class="icon-shopping-cart"></i>  <span id="AddToCartText">Preorder</span></a>';
            variant_quantity.hide();
          }else{
            shippingMsg = '';
            buttonHtml = '<a href="'+notifymeUrl+'" target="_blank" class="notifyme_btn btn">Notify Me</a>';
          }
        }
      }

      variant_stock_msg.html('<div id="variant-inventory"><span class="instock clr"> <i class="icon-check"></i> ' + stockMessage + '</span></div>');
      variant_addtocart_button.html(buttonHtml);

      shippingHtml += '<ul class="shipping_html">';
      if(shippingMsg!=""){
        shippingHtml += '<li class="shipping_msg_html">';
        shippingHtml += '<div class="clr ship"><p><i class="fa fa-truck"></i> ' + shippingMsg + '</p></div>';
        shippingHtml += '</li>';
      }
      shippingHtml += '</ul>';
      variant_shipping_msg.html(shippingHtml);
      variant_shipping_msg.show();

    }else{
      //Digital Product
      var stockMessage = '';
      var buttonTitle = '';
      var buttonUrl = 'https://server.glassboxx.co.uk/addtobasket?sku=' + sku;      
      var aboutUrl = '';     
      var shippingMsg = '';
      var shippingHtml = '';
      var buttonClass = 'pre-order';
      var shipping_display_status = true;

      variant_quantity.hide();

      if(title.toLowerCase()=='ebook'){
        aboutUrl = 'https://pelagicpublishing.com/pages/ebooks';
        title = 'eBook';
      }else if(title.toLowerCase()=='audiobook'){
        aboutUrl = 'https://pelagicpublishing.com/pages/audiobooks';
        title = 'Audiobook';
      }else{
        aboutUrl = 'https://pelagicpublishing.com/pages/' + title.toLowerCase() + 's';
        title = title.toLowerCase();
      }
      var aboutText = 'About ' + title + 's';
      var otherBookText = 'Other ' + title + ' options';

      if(quantity>0){
        //Product In Stock
        stockMessage = 'Available';
        buttonTitle = 'Add to Basket';
      }else{
        //Product Out of Stock
        stockMessage = 'Publication: ' + publication;
        buttonTitle = 'Preorder';
        shippingMsg = 'Delivered automatically on publication';
        
        if(inventory_policy!="continue"){
          shippingMsg = '';
          buttonTitle = 'Notify Me';
          buttonUrl = notifymeUrl;
          buttonClass = "notifyme_btn";
          shipping_display_status = false;
        }
      }
      variant_stock_msg.html('<div id="variant-inventory"><span class="instock clr"> <i class="icon-check"></i> ' + stockMessage + '</span></div>');

      // variant_addtocart_button.html('<a href="' + buttonUrl + '" class="btn '+buttonClass+'" target="_blank">' + buttonTitle + '</a>');
      variant_addtocart_button.html('<button type="submit" name="add" id="AddToCart" class="btn '+buttonClass+'"><span id="AddToCartText">' + buttonTitle + '</span></a>');

      shippingHtml += '<ul class="shipping_html">';
      shippingHtml += '<li class="about_html"><a href="' + aboutUrl + '" target="_blank">' + aboutText + '</a></li>';
      if(shippingMsg!=""){
        shippingHtml += '<li class="shipping_msg_html">';
        shippingHtml += '<div class="clr ship"><p><i class="fa fa-truck"></i> ' + shippingMsg + '</p></div>';
        shippingHtml += '</li>';
      }

      if(asin!="" || us_asin!=""){
        shippingHtml += '<li class="other_options_html mb15">';
        // shippingHtml += '<a href="' + aboutUrl + '" target="_blank">' + otherBookText + '</a>';
        shippingHtml += '<span class="pr20">' + otherBookText + '</span>';

        if(asin!=""){
          shippingHtml += '<a href="https://www.amazon.co.uk/dp/'+asin+'/ref=nosim?tag=pelagic-21" class="btn pre-order" target="_blank">Amazon.co.uk</a>';
        }

        if(us_asin!=""){
          shippingHtml += '<a href="https://www.amazon.com/dp/'+us_asin+'/ref=nosim?tag=pel0a-20" class="btn pre-order" target="_blank">Amazon.com</a>';
        }
        
        shippingHtml += '</li>';
      }
      shippingHtml += '</ul>';
      if(!shipping_display_status){
        shippingHtml = '';
      }
      variant_shipping_msg.html(shippingHtml);
      variant_shipping_msg.show();
    }
  }, 300);
}

function setCookie(cname,cvalue,exhours) {
  if(cname=='delivery_region'){
    $("input[name=av_region][value=" + cvalue + "]").prop('checked', true);
  }
  const d = new Date();
  d.setTime(d.getTime() + (exhours*60*60*1000));
  let expires = "expires=" + d.toGMTString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setHeaderDeliveryRegion(rvalue){
  if(rvalue==""){
    rvalue = 'United_Kingdom';
  }
  var text = $('.region_dropdown dd ul li#'+rvalue+' a').find('span.region_logos').html();
  $(".region_dropdown dt a span").html(text);
}